import { Appeals } from 'http-requests';
import { applySnapshot, flow, getSnapshot, types } from 'mobx-state-tree';
import { RequestStateModel } from 'store/models/general-models';

export const AppealCategoryModel = types
  .model('AppealCategoryModel', {
    _id: types.optional(types.identifier, ''),
    name: types.optional(types.string, ''),
    description: types.optional(types.string, ''),
  })
  .volatile(() => ({
    updateStatus: RequestStateModel.create(),
    deleteStatus: RequestStateModel.create(),
  }))
  .views((self) => ({
    get snapshot() {
      return getSnapshot(self);
    },
  }))
  .actions((self) => ({
    updateField<K extends keyof typeof self.snapshot>(
      fieldName: K,
      value: typeof self[K]
    ) {
      self[fieldName] = value;
    },
    update: flow(function* (data: { name: string; description: string }) {
      try {
        self.updateStatus.loadingStates();
        const response = yield Appeals.UpdateAppealCategory(self._id, data);
        applySnapshot(self, response);
        self.updateStatus.successStates();

        return response;
      } catch (error) {
        self.updateStatus.errorStates();
        console.error(error);

        throw error;
      } finally {
        self.updateStatus.finallyStates();
      }
    }),
  }));
